namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_profile_register, {

		align: {
			items: 'flex-start',
		},

		gap: $mol_gap.block,
		
		Login_label: {
			Content: {
				align: {
					self: 'flex-start',
				},
			},
		},

		Submit: {
			// align: {
			// 	self: 'flex-start',
			// },
			margin: {
				top: '2rem',
				left: $mol_gap.block,
				right: $mol_gap.block,
				bottom: $mol_gap.block,
			},
		},

		Message: {
			color: 'red',
		},
		
	} )
	
}
